export default "__VITE_ASSET__Kt46749L__"